
import platform from '../util/platform';

// https://jsbin.com/vafaba/3/edit?html,js,console,output
var result = platform.is.GECKO || platform.is.TRIDENT || platform.is.EDGE;

export default function () {
  return result;
}
//# sourceMappingURL=tabsequence-area-at-img-position.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ally.js/esm/supports/tabsequence-area-at-img-position.js
// module id = 214
// module chunks = 0 1